module.exports = __webpack_public_path__ + "img/yilapao2.89b43436.jpg";